import local_storage_service from "@/services/utilities/local-storage";
import admin from "@/services/admin";
import i18n  from '@/i18n/i18n';

export default {
  updateAccessToken({
    commit
  }, token) {
    local_storage_service.setAccessToken(token);
    commit("updateAccessToken", token);
  },
  updateRefreshToken({
    commit
  }, token) {
    local_storage_service.setRefreshToken(token);
    commit("updateRefreshToken", token);
  },
  updateUserInfo({
    commit
  }, user_info) {
    local_storage_service.setUserInfo(user_info);
    if(user_info != null && user_info.type == 'user'){ i18n.locale = user_info.language_preference; }
    commit("updateUserInfo", user_info);
  },
  updateLanguagePreference({
    commit
  }, language_preference) {
    local_storage_service.setLanguagePreference(language_preference);
    i18n.locale = (language_preference != null) ? language_preference : 'en';
    commit("updateLanguagePreference", language_preference);
  },
  updateProgramCodeInfo({
    commit
  }, program_code) {
    local_storage_service.setProgramCodeInfo(program_code);
    commit("updateProgramCodeInfo", program_code);
  },
  // get admin permissions
  updatePermissions({
    commit,
    state
  }, data = {}) {

    if (state.permissions_promise) {
      return state.permissions_promise;
    }

    data.id = state.user_info.id;

    let promise = admin.permissions(data).then(response => {
      commit('updatePermissions', response.data.data.permissions);
    });

    commit('updatePermissionsPromise', promise);
    return promise;
  },
}
